import type { HeadlineResponsePersonBaseRelatedPagedData } from '@on3/api';
import { TextLink } from 'components/UI/Link/TextLink';
import { Text } from 'components/UI/Typography/Text';

import styles from './CoachNews.module.scss';
import { CoachNewsItem } from './CoachNewsItem';

interface ICoachNewsProps {
  coachArticles: HeadlineResponsePersonBaseRelatedPagedData;
}
export const CoachNewsModule = ({ coachArticles }: ICoachNewsProps) => {
  const { list, relatedModel, pagination } = coachArticles;
  const viewAllCoachNewsRoute = `/db/coach/${relatedModel?.slug}/news/`;
  const viewAllCoachesArticles = pagination && pagination?.count >= 6;

  return (
    <section className={styles.playerNews}>
      <header className={styles.title}>
        <Text variant="h6">{`${relatedModel?.lastName || ''} News`}</Text>
      </header>
      {list?.length ? (
        list?.map((item) => {
          return <CoachNewsItem {...item} key={item.key} />;
        })
      ) : (
        <Text variant="caption">No News</Text>
      )}
      {viewAllCoachesArticles && (
        <footer className={styles.footer}>
          <TextLink href={viewAllCoachNewsRoute}>View All</TextLink>
        </footer>
      )}
    </section>
  );
};
